module.exports = __webpack_public_path__ + "static/media/face.10f2685b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/face.png
// module id = 153
// module chunks = 0